module.exports = __webpack_public_path__ + "img/session4_bg.dce28288.png";